export const ABOUT_YOU: Record<AboutYouScreenNames, string> = {
	AY_INTRO_0: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>AY_INTRO_1</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>INTRO</strong>
            </p>
        </div>
    `,

	AY_INTRO_1: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q22</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>INTRO</strong>
            </p>
        </div>
    `,

	Q22: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>"One" or "Seven or more"</td>
                    <td>ABOUT_YOU</td>
                    <td>Q23</td>
                </tr>
                <tr>
                    <td>Any other option</td>
                    <td>ABOUT_YOU</td>
                    <td>Q23_1</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	Q23: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q24</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	Q23_1: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q24</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
            <p>This will display up to 6 fields asking for the names of the people that live in your house.</p>
            <p>Yourself - the options start at 18-24</p>
            <p>The other options include ages below 18</p>
        </div>
    `,

	Q24: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q25</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
            <p>"I use a term not listed" reveals a text input</p>
        </div>
    `,

	Q25: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q26</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	Q26: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q27</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	Q27: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q28</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
            <p>"Prefer not to say" checkbox disables and clears the likert scales</p>
        </div>
    `,

	Q28: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If you select a region</td>
                    <td>ABOUT_YOU</td>
                    <td>Q28_1</td>
                </tr>
                <tr>
                    <td>If you skip the question</td>
                    <td>ABOUT_YOU</td>
                    <td>Q29</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	Q28_1: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q29</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
            <p>This uses the answer from Q28 to limit the list of postcode options to their selected region</p>
            <p>To make this clear to the user, the field labels include their selected region</p>
        </div>
    `,

	Q29: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If they have no dog</td>
                    <td>ABOUT_YOU</td>
                    <td>Q30  (Non dog version of hobbies and interests)</td>
                </tr>
                <tr>
                    <td>If they have are a dog owner</td>
                    <td>ABOUT_YOU</td>
                    <td>Q30_1 (Non dog version of hobbies and interests)</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
            <p>There is multiple ways they can be determined to be a non-dog-owner</p>
            <p>1. If they select the first option in Q1</p>
            <p>2. If they come in through the warm route and they answer W2 as "no"</p>
        </div>
    `,

	Q30: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q31</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	Q30_1: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>N/A</td>
                    <td>ABOUT_YOU</td>
                    <td>Q31</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
        </div>
    `,

	Q31: /*html*/ `
        <div>
            <h5>Routing</h5>
            <table>
                <thead>
                    <tr>
                        <th>Option(s)</th>
                        <th>Next Route</th>
                        <th>Next Screen</th>
                    </tr>
                </thead>
                <tr>
                    <td>If they have more than one dog</td>
                    <td>SUBSEQUENT_DOG</td>
                    <td>Q32</td>
                </tr>
                <tr>
                    <td>If only have one dog</td>
                    <td>GLOBAL</td>
                    <td>END_OF_SURVEY</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>
                <strong>OPTIONAL</strong>
            </p>
            <p>This is the consent page</p>
            <p>Choosing YES reveals the contact details input</p>
            <p>Clicking NEXT will trigger the first soft submission</p>
        </div>
    `,
};
